import { useContext, useState } from "react";
import Menu from "@mui/material/Menu";
import usuarioDesconhecido from "static/cloud21/header/usuario-desconhecido.png";
import gfMain from "static/cloud21/integracaoGF/gf-main.png";
import { Divider } from "@material-ui/core";
import { FaSignOutAlt } from "react-icons/fa";
import { UserContext } from "context/UserContext";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { ModalRedefinirSenhaUsuario } from "./ModalRedefinirSenhaUsuario";
import { makeStyles } from "@material-ui/core/styles";

interface UserMenuProps {
  isUserMenuAberto: HTMLElement | null;
  setIsUserMenuAberto: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

const useStyles = makeStyles((theme) => ({
  customDivider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: "#5c5a5a",
  },
}));

const UserMenu: React.FC<UserMenuProps> = (props) => {
  const { redirectToV1 } = IntegracaoV1();
  const { usuarioLogado, logoutContext } = useContext(UserContext);
  const [showModalAlterarSenha, setShowModalAlterarSenha] = useState(false);
  const handleClose = () => {
    props.setIsUserMenuAberto(null);
  };
  const custonDivider = useStyles().customDivider;

  const renderImagemDoUsuario = () => {
    return (
      <div className={"header-usuario-imagem"}>
        <img
          alt="avatar"
          src={usuarioDesconhecido}
          style={{ width: 80, height: 80, borderRadius: "50%" }}
        />
        <div>{usuarioLogado.nome}</div>
      </div>
    );
  };

  const renderOpcoes = () => {
    return (
      <div className={"header-usuario-opcoes"}>
        <div className={"header-usuario-topico"} onClick={() => redirectToV1("minha-conta")}>
          Minha conta no Group Condomínios
        </div>
        <Divider className={custonDivider} />
        <div
          className={"header-usuario-topico"}
          onClick={() => {
            props.setIsUserMenuAberto(null);
            setShowModalAlterarSenha(!showModalAlterarSenha);
          }}
        >
          Alterar senha
        </div>
        <Divider className={custonDivider} />
        <div
          className={"header-usuario-topico-img"}
          onClick={() => redirectToV1("/integracao-group-financeiro")}
        >
          <img alt="logo group financeiro" className="logo-gf" src={gfMain} />
          <div>GROUP financeiro</div>
        </div>
        <Divider className={custonDivider} />
        <div className={"header-usuario-topico"} onClick={logoutContext}>
          <FaSignOutAlt /> Sair
        </div>
      </div>
    );
  };

  return (
    <>
      <Menu
        anchorEl={props.isUserMenuAberto}
        open={Boolean(props.isUserMenuAberto)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {renderImagemDoUsuario()}
        <Divider className={custonDivider} />
        {renderOpcoes()}
      </Menu>
      <ModalRedefinirSenhaUsuario
        showModal={showModalAlterarSenha}
        onCloseModal={() => setShowModalAlterarSenha(false)}
      />
    </>
  );
};

export default UserMenu;
